// extracted by mini-css-extract-plugin
export default {"htmlDisplay":"htmlDisplay__htmlDisplay___O2B6Y"};